<div class="device-root container">

  <h3 class="page-title mb-4">Cihaz Yönetimi</h3>
  <!-- Hak Badge -->
  <div class="device-badge mb-4">
    <div class="badge-icon">
      <i class="fa fa-shield-halved"></i>
    </div>
    <div class="badge-text">
      <span class="badge-title">Kalan Doğrulama Hakkınız</span>
      <span class="badge-count">{{ deviceCount }}</span>
      <p class="badge-desc">
      <p>
        Her öğrenciye adil ve eşit hak sağlamak amacıyla, ayda <strong>2</strong> cihaz doğrulama hakkı
        verilmektedir.<br>
        Bu hak, öğrencilerin haklarını korumak, mağduriyet oluşmasını önlemek ve sürecin adil yürütülmesini sağlamak
        için tasarlanmıştır.
      </p>
      <hr>
      <h4>Lütfen dikkate alınız:</h4>
      <ul>
        <li>Sadece doğrulama yapılmış cihazlar üzerinden yoklamaya katılabilirsiniz.</li>
        <li>Başka cihazlardan giriş yapılması durumunda yoklamaya erişim engellenir.</li>
        <li>Hakkınız dolduğunda yeni cihaz ekleyemez veya yoklamaya katılamazsınız.</li>
        <li>Bu sistem, tüm öğrencilerin eşit şartlarda katılımını sağlamak ve haksız avantajları önlemek için
          uygulanmaktadır.</li>
      </ul>

      <p>
      Cihaz doğrulama hakkınız dolduğunda veya cihaz değişikliği yapmanız gerektiğinde,
      aşağıdaki buton üzerinden öğrenci işlerine gerekçeniz ile beraber geri bildirim formunu doldurarak göndermeniz gerekmektedir.
    </p>
    <button class="limit-button" (click)="router.navigate(['/feedback'])">
      <i class="fa fa-paper-plane"></i> Geri Bildirim Gönder
    </button>

    </div>
  </div>



  <!-- Kayıtlı Cihazlar -->


  <div *ngIf="deviceId; else noDevice">
    <div class="device-card">
        <div class="section-title">Kayıtlı Cihazlar</div>
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <i class="fa fa-phone icon"></i>
          <span class="device-text">Cihaz ID: {{ deviceId }}</span>
        </div>

        <button class="delete-btn" (click)="deleteDevice()">
          <i class="fa fa-trash"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- Kayıtlı cihaz yok -->
  <ng-template #noDevice>
    <div class="empty-box text-center">
      <i class="fa fa-inbox fs-1"></i>
      <p>Kayıtlı cihaz bulunamadı.</p>
    </div>
  </ng-template>

  <div class="mt-4">


    <!-- HAKKİ DOLMUŞSA UYARI -->
    <div *ngIf="deviceCount <= 0">
      <div class="warning-card">
        <div class="d-flex">
          <i class="fa fa-exclamation-triangle-fill warn-icon"></i>
          <p>
            Bu ay için cihaz tanımlama hakkınız dolmuştur.
            Sorun olduğunu düşünüyorsanız aşağıdan geri bildirim gönderin.
          </p>
        </div>

        <button class="btn btn-danger w-100 mt-3" (click)="router.navigate(['/feedback'])">
          <i class="fa fa-chat-left-text me-1"></i> Geri Bildirim Gönder
        </button>
      </div>
    </div>



    <!-- YENİ CİHAZ EKLE -->
    <div *ngIf="deviceCount > 0">
      <button class="btn btn-success w-100 add-btn" (click)="addNewDevice()">
        <i class="fa fa-plus-circle me-1"></i> Yeni Cihaz Ekle
      </button>
    </div>

  </div>
</div>
